import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Avatar from './Avatar';

const Container = styled.div`
  margin: 10px;
`

const Channel = ({
  data,
  onSubmit,
  openChannelNameDialog,
  ...other
}) => (
  <Container {...other}>
    <Avatar
      onSubmit={(newData, callback) => onSubmit({ channel_image: newData.channel_image }, callback)}
      openChannelNameDialog={openChannelNameDialog}
      data={data}/>
  </Container>
)

Channel.propTypes = {
  data: PropTypes.object,
  onSubmit: PropTypes.func,
};

Channel.defaultProps = {
  data: null,
};

export default Channel;
